import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Api from '../../../service/Api';
import { getUser } from '../../services/Storage.Utils';
import './styles.css';

function normalizePhone(phone) {
	if (!phone) return '';
	var digits = String(phone).replace(/[^0-9]/g, '');
	if (digits.length > 9 && digits.startsWith('56')) {
		digits = digits.substring(2);
	}
	return digits.slice(-9);
}

function maskPhone(phone) {
	if (!phone || phone.length < 4) return '****';
	return '*'.repeat(phone.length - 4) + phone.slice(-4);
}

function ModalWhatsAppCode({ isOpen, toggle, onVerified }) {
	const [code, setCode] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');

	useEffect(() => {
		if (isOpen) {
			setCode('');
			setError('');
			fetchPhoneAndSendCode();
		}
	}, [isOpen]);

	async function fetchPhoneAndSendCode() {
	
		setLoading(true);
		try {
			const user = getUser();
			const rut = user ? user.rut : '';
			const response = await Api.getClienteInformacion({ rut });
			
			console.log('[fetchPhoneAndSendCode] Respuesta del backend:', response);

			if (response.status === 'success' && response.result && response.result.TELEFONO) {
				const phone = normalizePhone(response.result.TELEFONO);
				if (/^9\d{8}$/.test(phone)) {
					setPhoneNumber(phone);
					sendCode(phone);
				} else {
					setError('No se pudo obtener un número de teléfono válido.');
					setLoading(false);
				}
			} else {
				console.error('[fetchPhoneAndSendCode] Error del backend:', response);
				setError('No se ha podido obtener información del cliente.');
				setLoading(false);
			}
		} catch (err) {
			console.error('[fetchPhoneAndSendCode] Error de conexión:', err);
			setError('No se ha podido obtener información del cliente.');
			setLoading(false);
		}

		// setPhoneNumber("902530468");
		// sendCode("902530468");
	}

	async function sendCode(phone) {
		const numero = phone || phoneNumber;
		setLoading(true);
		setError('');
		try {
			const response = await Api.whatsappSendCode({ phone_number: numero });
			if (response.status === 'success') {
				} else {
				setError(response.message || 'No se pudo enviar el código. Intente nuevamente.');
			}
		} catch (err) {
			setError('Error de conexión. Intente nuevamente.');
		}
		setLoading(false);
	}

	async function handleVerify() {
		if (!code || code.length !== 6) {
			setError('Ingresa un código de 6 dígitos.');
			return;
		}
		setLoading(true);
		setError('');
		try {
			const response = await Api.whatsappVerifyCode({ phone_number: phoneNumber, code: code });
			if (response.valid === true) {
				onVerified();
			} else {
				setError(response.message || 'El código ingresado es incorrecto. Inténtalo nuevamente.');
			}
		} catch (err) {
			setError('Error de conexión. Intente nuevamente.');
		}
		setLoading(false);
	}

	function handleResend() {
		setCode('');
		setError('');
		sendCode();
	}

	return (
		<Modal isOpen={isOpen} toggle={toggle} centered className="modal-whatsapp-code">
			<ModalBody>
				<button type="button" className="close-btn" onClick={toggle}>&times;</button>
				<h5 className="modal-title-whatsapp">Verificación de número telefónico</h5>
				<p className="modal-desc">
					Te enviamos un código de verificación por WhatsApp al número registrado: <strong>{maskPhone(phoneNumber)}</strong>
				</p>

				<label className="modal-label">Ingresa el código para confirmar tu número.</label>
				<input
					type="text"
					className="modal-input-code"
					placeholder="Ingresa tu código"
					value={code}
					onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
					maxLength={6}
					disabled={loading}
				/>

				{error && <p className="modal-error">{error}</p>}

				<button
					className="btn-verificar"
					onClick={handleVerify}
					disabled={loading}
				>
					{loading ? 'Procesando...' : 'Verificar código'}
				</button>

				<button type="button" className="btn-reenviar" onClick={handleResend} disabled={loading}>
					Volver a enviar código
				</button>
			</ModalBody>
		</Modal>
	);
}

export default ModalWhatsAppCode;
